<!-- Skeleton loading — shown while data is being fetched -->
<div class="grid-skeleton" *ngIf="isLoading && (!rowData || rowData.length === 0)">
  <div class="skeleton-header">
    <div class="skeleton-cell skeleton-cell--check"></div>
    <div class="skeleton-cell skeleton-cell--lg"></div>
    <div class="skeleton-cell"></div>
    <div class="skeleton-cell"></div>
    <div class="skeleton-cell skeleton-cell--sm"></div>
    <div class="skeleton-cell skeleton-cell--sm"></div>
  </div>
  <div class="skeleton-row" *ngFor="let r of [1,2,3,4,5,6,7,8]">
    <div class="skeleton-cell skeleton-cell--check">
      <div class="skeleton-shimmer skeleton-shimmer--circle"></div>
    </div>
    <div class="skeleton-cell skeleton-cell--lg">
      <div class="skeleton-shimmer" style="width: 65%"></div>
    </div>
    <div class="skeleton-cell">
      <div class="skeleton-shimmer" style="width: 80%"></div>
    </div>
    <div class="skeleton-cell">
      <div class="skeleton-shimmer" style="width: 55%"></div>
    </div>
    <div class="skeleton-cell skeleton-cell--sm">
      <div class="skeleton-shimmer" style="width: 70%"></div>
    </div>
    <div class="skeleton-cell skeleton-cell--sm">
      <div class="skeleton-shimmer" style="width: 90%"></div>
    </div>
  </div>
</div>

<div class="all-show-grid" [style.display]="isLoading && (!rowData || rowData.length === 0) ? 'none' : 'block'">
  <ag-grid-angular
    *ngIf="!isServerSide"
    [class]="gridClass"
    [gridOptions]="gridOptions"
    [defaultColDef]="defaultColDef"
    [pagination]="pagination"
    [headerHeight]="headerHeight"
    [paginationPageSize]="paginationPageSize"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [columnDefs]="columnDefs"
    [domLayout]="domLayout"
    (gridReady)="agGridReady($event)"
    [rowHeight]="rowHeight"
    [rowData]="rowData"
    [suppressMovableColumns]="true"
    [treeData]="treeData"
    [getDataPath]="getDataPath"
    #grid
  >
  </ag-grid-angular>
</div>
<div *ngIf="isServerSide" class="all-show-grid" [style.display]="isLoading && (!rowData || rowData.length === 0) ? 'none' : 'block'">
  <ag-grid-angular
    [class]="gridClass"
    [gridOptions]="gridOptions"
    [defaultColDef]="defaultColDef"
    [rowModelType]="rowModelType"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [pagination]="pagination"
    [rowHeight]="rowHeight"
    [headerHeight]="headerHeight"
    [paginationPageSize]="paginationPageSize"
    [cacheBlockSize]="cacheBlockSize"
    [columnDefs]="columnDefs"
    [domLayout]="domLayout"
    (gridReady)="agGridReady($event)"
    [treeData]="treeData"
    [getDataPath]="getDataPath"
    [rowData]="rowData"
    [suppressMovableColumns]="true"
    #grid
  >
  </ag-grid-angular>
</div>

<!-- Compact Pagination Controls -->
<div class="compact-pagination" *ngIf="showCustomPagination && hasGridData() && totalRecords > 0" [class.loading]="isLoading">
  
  <!-- Left side: Records info -->
  <div class="pagination-info">
    <span class="records-count" *ngIf="!isLoading">
      {{ totalRecords }} {{ totalRecords === 1 ? 'item' : 'items' }}
    </span>
    <span class="loading-indicator" *ngIf="isLoading">
      <i class="loading-spinner"></i> Loading...
    </span>
  </div>
  
  <!-- Center: Navigation -->
  <div class="nav-section">
    <button 
      class="nav-button"
      [disabled]="currentPage === 0 || isLoading"
      (click)="goToFirstPage()"
      title="First">
      <i class="icon-first"></i>
    </button>
    
    <button 
      class="nav-button"
      [disabled]="currentPage === 0 || isLoading"
      (click)="goToPreviousPage()"
      title="Previous">
      <i class="icon-prev"></i>
    </button>
    
    <div class="page-info">
      <input 
        type="number" 
        class="page-input"
        [value]="currentPage + 1"
        [min]="1"
        [max]="calculatedTotalPages"
        [disabled]="isLoading"
        (blur)="onPageInputChange($event)"
        (keydown.enter)="onPageInputChange($event)"
        title="Current page">
      <span class="page-total">/ {{ calculatedTotalPages }}</span>
    </div>
    
    <button 
      class="nav-button"
      [disabled]="currentPage >= calculatedTotalPages - 1 || isLoading"
      (click)="goToNextPage()"
      title="Next">
      <i class="icon-next"></i>
    </button>
    
    <button 
      class="nav-button"
      [disabled]="currentPage >= calculatedTotalPages - 1 || isLoading"
      (click)="goToLastPage()"
      title="Last">
      <i class="icon-last"></i>
    </button>
  </div>
  
  <!-- Right side: Page size selector -->
  <div class="page-size-section">
    <select 
      class="page-size-select" 
      (change)="onPageSizeChange($event)" 
      [value]="pageSize" 
      [disabled]="isLoading"
      title="Items per page">
      <option value="10">10</option>
      <option value="20">20</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </select>
  </div>
  
</div>
